import { SITE_NAME } from '../../../../../../config/environment';

const adaptData = ({ data, searchQuery }) => {
    const descriptionMeta = {
        name: 'description',
        content: `Privacy Policy - ${SITE_NAME}`
    };

    return {
        title: `Privacy Policy - ${SITE_NAME}`,
        meta: [descriptionMeta]
    }
}

export default adaptData;
